export const environment = {
	env: 'production',
	intercomAppId: 'ssl1wxqp',
	production: true,
	googleMapsAPIKey: 'AIzaSyC4OOpkzFJ-6WFzRHcBqG-H7XYOjxs7iaI',
	stripePublishableAPIKey: 'pk_live_51J5Kh0EgCSMDz09z8UfvZ9OoREi7J0MV3GrYYFJMTwsYqe5D3QPYucn8QFmIu7Vx4yuJ39R3G75nlYBqx5eFPHBG005cyYzGX1',
	colors: {
		primary0: '#0EABF7',
		primary: '#078BCB',
		primary2: '#067ab2',
		primary3: '#05699a',
		accentWhite: '#eff6ff',
		accent1: '#bfdbfe',
		accent2: '#60a5fa',
		lightPrimary: '#339bff26',
		//primary-5% opacity
		primary5: '#078BCB0D',
	},
	stripePlans: [
		{ plan: 'Business', key: { monthly: 'price_1QjWF1EgCSMDz09zKN3Vy0Vc', yearly: 'price_1QjER5EgCSMDz09zgHQoBAKO' } },
	],
	posthog: true,
	countries: ['australia', 'new zealand'],
	us: false,
	baseUrl: 'https://app.paintprojex.com',
	obiKey: '25e030eb-1db5-4629-8849-d3afda65d19f',
	currency: {
		code: 'AUD',
		symbol: '$',
		locale: 'en-AU'
	}
};
